import React, { Component, useState, useEffect } from "react";
import { postData, getData, patchData, deleteData } from "../../util/Fetch";
import FullCalendar, { formatDate } from "@fullcalendar/react";
import dayGridPlugin, { DayGridView } from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ReserveModal from "./ReserveModal";
import swal from "sweetalert";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "./Calander.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import zhTW from "date-fns/locale/zh-TW";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

const EventCalander = () => {
  const [events, setEvents] = React.useState([]);
  const [filterEvents, setFilterEvents] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectDate, setSelectDate] = React.useState();
  const calendarComponentRef = React.createRef();
  const [tooltip, setTooltip] = React.useState({
    display: false,
    content: "",
    position: { x: 0, y: 0 },
  });
  const [calanderSearchParam, setCalanderSearchParam] = React.useState({
    SalonId: 0,
    StaffId: 0,
    Role: 0,
    DateFrom: "0001-01-01 00:00:00Z",
    DateTo: "0001-01-01 00:00:00Z",
  });
  const [config, setConfig] = useState({
    id: 0,
    reserveDuration: 0,
    officialDayoff: [],
    reserveLimitDay: 0,
    endHour: 0,
    startHour: 0,
    startTime: 0
  });
  const [deltaTime, setDeltaTime] = React.useState({
    id: 0,
    deltaYears: 0,
    deltaMonths: 0,
    deltaDay: 0,
    deltaMilliseconds: 0,
  });
  const [selectStartTime, setSelectStartTime] = React.useState();
  const [selectEndTime, setSelectEndTime] = React.useState();
  const [stylists, setStylists] = React.useState([]);
  const [stylist, setStylist] = React.useState(0);
  const [selectReserve, setSelectReserve] = React.useState(undefined);

  useEffect(() => {
    getStylists();
  }, []);

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = () => {
    getData("config").then((res) => {
      setConfig(res);
    });
  };

  const handleEventMouseEnter = (mouseEnterInfo) => {
    const event = mouseEnterInfo.event;
    const eventEl = mouseEnterInfo.el;
    const rect = eventEl.getBoundingClientRect();

    // 準備顯示的資訊
    const detail = event._def.extendedProps.detail;

    // 設定tooltip狀態
    setTooltip({
      display: true,
      content: detail,
      position: {
        x: rect.left + window.scrollX,
        y: rect.bottom + window.scrollY,
      },
    });
  };

  // 滑鼠離開事件時觸發
  const handleEventMouseLeave = () => {
    setTooltip({ ...tooltip, display: false });
  };

  const updateCalanderTime = () => {
    patchData("Calander", { ...deltaTime, type: "time" }).then((res) => {
      if (res === true) {
        swal("修改成功", "預約時間修改成功", "success");
      }
    });
  };

  useEffect(() => {
    if (deltaTime.id == 0) {
      return;
    }
    swal({
      icon: "warning",
      title: "詢問",
      text: "是否確認要修改",
      buttons: {
        cancel: {
          text: "取消",
          value: "cancel",
          visible: true,
        },
        confirm: {
          text: "確定",
          value: "ok",
          visible: true,
        },
      },
    }).then((value) => {
      if (value === "ok") {
        updateCalanderTime();
      }
      if (value === "cancel") {
        setDeltaTime({
          id: 0,
          deltaYears: 0,
          deltaMonths: 0,
          deltaDay: 0,
          deltaMilliseconds: 0,
        });
        GetEvents();
      }
    });
  }, [deltaTime]);

  useEffect(() => {
    GetEvents();
  }, [calanderSearchParam]);

  useEffect(() => {
    filterEventCalander(stylist);
  }, [stylist, events]);

  const filterEventCalander = (id) => {
    if (id === 0) {
      setFilterEvents(events);
    } else {
      setFilterEvents(events.filter((x) => x.staffId == id));
    }
  };

  const hangleChangeDate = (date) => {
    setSelectDate(date);
    let calendarApi = calendarComponentRef.current.getApi();
    calendarApi.gotoDate(date); // call a method on the Calendar object
  };

  const closeServiceModal = () => {
    setSelectReserve(undefined);
    setOpen(false);
  };

  const handleSelectChange = (e) => {
    setStylist(e.target.value);
  };

  const getStylists = () => {
    getData("Stylist").then((res) => {
      setStylists(res);
    });
  };

  const handleDatesSet = (rangeInfo) => {
    setCalanderSearchParam({
      DateFrom: rangeInfo.startStr,
      DateTo: rangeInfo.endStr,
    });
  };

  const handleCalanderDrop = (event) => {
    setDeltaTime({
      deltaMilliseconds: event.delta.milliseconds,
      deltaDay: event.delta.days,
      deltaMonths: event.delta.months,
      deltaYears: event.delta.years,
      id: parseInt(event.event._def.publicId),
    });
  };

  const handleCalanderEvent = (event) => {};

  const handleDateSelect = (event) => {
    setSelectStartTime(event.start);
    setSelectEndTime(event.end);
    setSelectReserve(undefined);
    setOpen(true);
  };

  const showdelteForm = (event) => {
    swal({
      title: "請問要刪除預約嗎?",
      text: "預約資料： " + event.event._def.detail,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteData("Calander", parseInt(event.event._def.publicId)).then(
          (res) => {
            if (res === true) {
              setEvents(
                events.filter((x) => x.id != event.event._def.publicId)
              );
              swal("刪除成功", {
                icon: "success",
              });
            }
          }
        );
      }
    });
  };

  const handleEventClick = (event) => {
    //title -> event.event._def.title
    //time -> event.event._instance.range.start

    swal({
      icon: "info",
      title: "預約資料",
      text: event.event._def.extendedProps.detail,
      buttons: {
        cancel: {
          text: "取消",
          value: "cancel",
          visible: true,
        },
        confirm: {
          text: "修改",
          value: "edit",
          visible: true,
        },
        danger: {
          text: "刪除",
          value: "delete",
          visible: true,
        },
      },
    }).then((value) => {
      if (value === "delete") {
        showdelteForm(event);
      }
      if (value === "edit") {
        setSelectReserve(event.event._def.extendedProps);
        setOpen(true);
      }
    });

    /*
        swal({
            title: "請問要刪除預約嗎?",
            text: "預約資料： " + event.event._def.title,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                deleteData("Calander", parseInt(event.event._def.publicId)).then(res => {
                    if(res === true){
                        setEvents(events.filter(x => x.id != event.event._def.publicId));
                        swal("刪除成功", {
                            icon: "success",
                          });
                    }
                })  
            }
          });
          */
  };

  return (
    <div>
      <ReserveModal
        GetEvents={GetEvents}
        open={open}
        closeModel={closeServiceModal}
        reserve={selectReserve}
        reserveTimeFrom={selectStartTime}
        reserveTimeTo={selectEndTime}
        setEvents={setEvents}
        events={events}
        stylists={stylists}
      />
      <Stack direction="row" sx={{ p: 3 }}>
        <FormControl>
          <InputLabel id="stylist">員工選單</InputLabel>
          <Select
            id="stylist"
            value={stylist}
            label="預約時段最小間隔(分鐘)"
            onChange={handleSelectChange}
          >
            <MenuItem key={0} value={0}>
              {"全部"}
            </MenuItem>
            {stylists.map((x) => (
              <MenuItem key={x.staffId} value={x.staffId}>
                {x.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <LocalizationProvider
          adapterLocale={zhTW}
          dateAdapter={AdapterDateFns}
          sx={{ width: 120, mt: 2 }}
        >
          <DatePicker
            sx={{ width: 120 }}
            label="日期選擇器"
            value={selectDate}
            onChange={(newValue) => {
              hangleChangeDate(newValue);
            }}
            inputFormat={"yyyy/MM/dd"}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Stack>
      <FullCalendar
        headerToolbar={{
          left: "prev,next today", // 左邊放置上一頁、下一頁和今天
          center: "title", // 中間放置標題
          right: "dayGridMonth,dayGridWeek,timeGridWeek,timeGridDay",
          locale: "zh-tw",
        }}
        titleFormat={{
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }}
        dayHeaderFormat={{ weekday: "short" }}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        html={true}
        buttonText={{
          today: "今天",
          month: "月",
          week: "周",
          day: "日",
        }}
        contentHeight={600}
        weekends={true}
        editable={true}
        selectable={true}
        events={filterEvents}
        eventDisplay="block"
        eventDrop={handleCalanderDrop}
        eventsSet={handleCalanderEvent}
        select={handleDateSelect}
        eventClick={handleEventClick}
        datesSet={handleDatesSet}
        eventMouseEnter={handleEventMouseEnter}
        eventMouseLeave={handleEventMouseLeave}
        locale={"zh-tw"}
        displayEventEnd={false}
        ref={calendarComponentRef}
        slotMinTime={`${config.startTime}:00`}
        slotMaxTime={`24:00`}
        slotDuration={"00:15:00"}
        longPressDelay="100"
        eventTimeFormat={{
          // like '14:30:00'
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }}
      />
      {tooltip.display && (
        <div
          style={{
            position: "absolute",
            left: `${tooltip.position.x}px`,
            top: `${tooltip.position.y}px`,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "4px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            zIndex: 1000,
            maxWidth: "300px",
            wordBreak: "break-word",
          }}
        >
          {tooltip.content}
        </div>
      )}
    </div>
  );

  function GetEvents() {
    getData("Calander", calanderSearchParam).then((res) => {
      setEvents(res);
    });
  }
};

export default EventCalander;
